<template>
  <div class="hello">
    <el-container>
      <div class="xdHeader" id="xdHeader">
        <div class="mainContainer disFlex" style="align-items: center;height: 114px;">
          <img style="width: 53px;height: 53px;" src="@/assets/images/zhawlogol.png" />
          <span
            style="color: #fff;font-size: 36px;letter-spacing: 2px;font-weight: 600;padding-left: 12px;">智慧安卫在线课堂</span>
        </div>
      </div>
      <div id="globalheader">
        <global-header v-if="isCommonH" @changerouter="allchangeFlag" :activeFlag="activeFlag"
          :currentUser="currentUser" :isDenglu="isDenglu" @getUserInfo="getUserInfo" :wjSrc="wjSrc" />
        <cpxq-header :activeFlag="cpFlag" @changeCpitype="changeCpitype" v-if="!isCommonH"
          @changeHeader="changeHeader" :currentUser="currentUser" />
      </div>
      <el-main>
        <div>
          <!-- <transition :name="transitionName"> -->
          <router-view @changeCpitype="changeCpitype" @changerouter="allchangeFlag" :activeFlag="activeFlag"
            :activeName="cpFlag" :currentUser="currentUser" :isDenglu="isDenglu" @changeHeader="changeHeader"
            @getUserInfo="getUserInfo" :wjSrc="wjSrc" :isCommonH="isCommonH" :zyzcList="zyzcList" :zyjnList="zyjnList"
            :KsBtnIsfixed="KsBtnIsfixed" />
          <!-- </transition> -->

          <div class="allright-fixed">
            <div class="right-fixed">
              <!-- <div class="flex1">
                <div style="margin-bottom: 5px;" @click="getKf()"><img src="@/assets/images/kftx.png" /></div>在线客服

              </div> -->
              <div class="flex1">
                <div>
                  <div style="margin-bottom: 5px;"><img src="@/assets/images/kfdh.png" /></div>电话客服
                </div>
                <div class="showNot" style="width: 199px;text-align: left;color: #333;margin-top: 20px;">
                  <div class="kfdhtit">客服电话</div>
                  <div class="kfdhtit" style="margin-top: 10px;">13137703753</div>
                  <div><img src="@/assets/images/kfwx.jpg" style="width: 120px;height: 120px;" /></div>
                </div>
              </div>
              <div class="flex1">
                <div>
                  <div style="margin-bottom: 5px;"><img src="@/assets/images/wxgzh.png" /></div>公众号
                </div>
                <div class="showNot" style="width: 243px;text-align: center;color: #333;margin-top: -20px;">
                  <div class="kfdhtit" style="margin-bottom: 20px;">扫码关注公众号</div>
                  <div><img src="@/assets/images/azapp.jpg" style="width: 80px;height: 80px;" /></div>
                </div>
              </div>
              <div class="flex1">
                <div>
                  <div style="margin-bottom: 5px;"><img src="@/assets/images/appic.png" /></div>移动端
                </div>
                <div class="showNot" style="width: 120px;text-align: center;color: #333;margin-top: -20px;">
                  <div class="disFlex">
                    <div class="flex2" style="">
                      <div class="kfdhtit" style="margin-bottom: 20px;">手机端</div>
                      <div><img src="@/assets/images/ktxcx.png" style="width: 80px;height: 80px;" /></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex1" @click="sybz">
                <div>
                  <div style="margin-bottom: 5px"><img src="@/assets/images/sybz3.png" /></div>使用帮助
                </div>
              </div>
            </div>
            <div class="toBack" @click="goTop()">
              <div style="margin: 5px 0px;"><img src="@/assets/images/tod.png" /></div>
              回到顶部
            </div>
          </div>



        </div>
      </el-main>
      <div class="bigRouterFooter" v-if="isShowBig">
        <div class="mainContainer disFlex between">
          <div class="flex3">
            <div class="footer-big-tit">快速导航</div>
            <div class="disFlex">
              <div class="flex1">
                <div class="footer-big-div" style="cursor: pointer;" @click="changeDh(1,'/Product')">宣教中心</div>
                <div class="footer-big-div" style="cursor: pointer;" @click="changeDh(2,'/Forensics')">取证查询</div>
                <!-- <div class="footer-big-div" style="cursor: pointer;" @click="changeDh(5,'/Company')"
                  v-if="isDenglu&&currentUser.roleCodes.indexOf('COM_ADMIN_AQKT')>=0">企业中心</div> -->
                <!-- </div>
              <div class="flex1"> -->
                <div class="footer-big-div" style="cursor: pointer;" @click="changeDh(3,'/Notice')">通知公告</div>
                <!-- <div class="footer-big-div" style="cursor: pointer;"
                  v-if="isDenglu&&currentUser.roleCodes.indexOf('COM_ADMIN_AQKT')=='-1'"
                  @click="changeDh(5,'/Learning')">学习中心</div> -->
              </div>
              <div class="flex1">
              </div>
            </div>
          </div>
          <div class="flex4">
            <div class="footer-big-tit">联系我们</div>
            <div class="footer-big-div">服务热线：13137703753</div>
            <div class="footer-big-div">联系邮箱： guangtong888@163.com </div>
            <div class="footer-big-div">办公时间：周一至周五 8:30-18:00</div>
            <div class="footer-big-div">公司地址：郑州市二七区航海中路219号十一层</div>
          </div>
          <!-- <div class="flex2">
            <div class="footer-big-tit" style="text-align: center;width: 160px;">下载安卓app</div>
            <div class="footer-big-div"><img src="@/assets/images/azapp.png" style="width: 160px;" /></div>
          </div>
          <div class="flex2">
            <div class="footer-big-tit" style="text-align: center;width: 160px;">下载苹果app</div>
            <div class="footer-big-div"><img src="@/assets/images/azapp.png" style="width: 160px;" /></div>
          </div>
          <div class="flex2">
            <div class="footer-big-tit" style="text-align: center;width: 160px;">扫码关注公众号</div>
            <div class="footer-big-div"><img src="@/assets/images/azapp.png" style="width: 160px;" /></div>
          </div> -->
        </div>
      </div>
      <el-footer
        style="background-color: #025A93;height: 56px;line-height: 56px;color: #FFFFFF;font-size: 12px;text-align: center;"
        class="cannotCopy">
        <!-- CopyRight © 2022-2021 All Right Reserved Henan Tianshun Safety Engineer Firm Co., Ltd. -->河南广通安全评价咨询有限公司
        版权所有
        <a href="https://beian.miit.gov.cn/" style="padding-left: 5px;color: #fff;text-decoration: underline;">豫ICP备19026038号-1</a>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
  import GlobalHeader from './GlobalHeader.vue';
  import CpxqHeader from './CpxqHeader.vue'
  import {
    getItype
  } from '@/assets/js/common.js';
  export default {
    name: 'Main',
    data() {
      return {
        currentUser: localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : null,
        transitionName: '',
        isDenglu: false,
        activeFlag: 0,
        isCommonH: true,
        cpFlag: 'first',
        conScroll: true,
        isShowBig: true,
        wjSrc: 'http://zhkt.tsanquan.com/jtzy/',
        zyzcList: [],
        zyjnList: [],
        KsBtnIsfixed: false,
        options: []
      }
    },
    components: {
      GlobalHeader,
      CpxqHeader
    },
    methods: {
      sybz: function(flag) {
        window.open(
          'https://zhkt.tsanquan.com/%E6%99%BA%E6%85%A7%E8%AF%BE%E5%A0%82%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf')
      },
      getKf: function() {
        // this.setWebsokit()
      },
      // 获取登陆人信息
      getUserInfo: function() {
        this.$axios.get('/getUserInfo.htm', {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.currentUser = data.data;

            localStorage.setItem('currentUser', JSON.stringify(data.data));
            this.isDenglu = true;
          } else {
            this.isDenglu = false;
            this.currentUser = null;
          }
        })
      },
      allchangeFlag: function(flag) {
        this.activeFlag = flag
      },
      changeDh: function(flag, path) {
        this.activeFlag = flag;
        this.$router.push(path);
      },
      changeHeader: function(flag) {
        this.isCommonH = flag
      },
      changeCpitype: function(flag) {
        this.cpFlag = flag
      },
      setWebsokit: function() {
        return;
        // 链接websokit
        layui.use(['layim', 'layer', 'jquery'], function() {
          var layim = layui.layim,
            $ = layui.jquery,
            layer = layui.layer;
          var chatUrl = 'ws://' + '192.168.0.108:8082/chatPush/' + token + '/' + userid + '/2/' + shenfen;

          //自定义客服窗口
          layim.config({
            brief: true //简约模式，不显示主面板
          }).chat({
            name: '在线客服', //名称
            type: 'friend', //聊天类型
            avatar: 'http://tp1.sinaimg.cn/5619439268/180/40030060651/1', //头像
            id: '17527e55b05d4d4cb44ebae6cd013c8f' //定义唯一的id方便你处理信息
          });

          createWebSocket(chatUrl, layim);
          // layim.setChatMin(); //收缩聊天面板

          //监听发送消息
          layim.on('sendMessage', function(res) {
            var mine = res.mine; //包含我发送的消息及我的信息
            var to = res.to; //对方的信息
            // if (!islogin) {
            res.mine.id = userid;
            res.mine.avatar = "/images/defaulttx.png";
            res.mine.username = username;
            res.to.username = to.name;
            res.to.status = "online";
            res.to.avatar = "/js/lay-module/layim397/dist/layim-assets/images/default.png";
            // }
            //监听到上述消息后，就可以轻松地发送socket了，如：
            socket.send(JSON.stringify({
              type: 2 //随便定义，用于在服务端区分消息类型
                ,
              senddata: res,
              pingtai: "2"
            }));
          });
        })
      },
      goTop: function() {
        $('#app').animate({
          scrollTop: 110
        }, 300);
      },
    },
    watch: { //使用watch 监听$router的变化
      $route(to, from) {
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态
        if (to.meta.index > from.meta.index) {
          //设置动画名称
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }
        if (to.fullPath.indexOf('/Company') >= 0 || to.fullPath.indexOf('/testQuestion') >= 0) {
          this.isShowBig = false
        } else {
          this.isShowBig = true;
        }
      }
    },
    created: function() {
      this.getUserInfo();
      // 获取路径
      var arr = ['/Home', '/Product','/Forensics', '/Notice', '/Company', '/Learning'];
      if (arr.indexOf(this.$route.path) != '-1') {
        this.activeFlag = arr.indexOf(this.$route.path);
      } else {
        this.activeFlag = 0
      };
      var url = "";
      //108网  crm
      if (window.location.host.indexOf('demo.tsanquan.com') != '-1') {
        url = 'http://dstatic.tsanquan.com';
      } else if (window.location.host.indexOf('localhost') != '-1') {
        url = 'http://192.168.0.108:8082/jtzy';
      } else {
        url = window.location.origin + '/jtzy';
      };
      this.wjSrc = url;
      getItype(this.$axios, ((res) => {
        this.zyzcList = JSON.parse(localStorage.getItem('zyzcList'));
        this.zyjnList = JSON.parse(localStorage.getItem('zyjnList'));
      }));
    },
    mounted: function() {
      var mainContainer = document.getElementById('app');
      var $this = this;
      var scrollFunc = function(e) {
        e = e || window.event;
        if (e.wheelDelta) { //第一步：先判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) { //当滑轮向上滚动时

            if ($this.$route.path == '/ProductDetail' && mainContainer.scrollTop < 100) {
              $this.isCommonH = true
            }
            // 考试页面的右侧的指示
            if (($this.$route.path == '/Kaoshi' || $this.$route.path == '/Ckjx') && mainContainer.scrollTop <=
              200) {
              $this.KsBtnIsfixed = false
            }

          } else if (e.wheelDelta < 0) { //当滑轮向下滚动时

            if ($this.$route.path == '/ProductDetail' && mainContainer.scrollTop > 500) {
              $this.isCommonH = false
            }
            // 考试页面的右侧的指示
            if (($this.$route.path == '/Kaoshi' || $this.$route.path == '/Ckjx') && mainContainer.scrollTop > 200) {
              $this.KsBtnIsfixed = true
            }
          }
        } else if (e.detail) { //Firefox滑轮事件
          if (e.detail > 0) { //当滑轮向上滚动时
            if ($this.$route.path == '/ProductDetail' && mainContainer.scrollTop < 100) {
              $this.isCommonH = true
            }
            // 考试页面的右侧的指示
            if (($this.$route.path == '/Kaoshi' || $this.$route.path == '/Ckjx') && mainContainer.scrollTop <=
              200) {
              $this.KsBtnIsfixed = false
            }
          }
          if (e.detail < 0) { //当滑轮向下滚动时
            if ($this.$route.path == '/ProductDetail' && mainContainer.scrollTop > 500) {
              $this.isCommonH = false
            }
            // 考试页面的右侧的指示
            if (($this.$route.path == '/Kaoshi' || $this.$route.path == '/Ckjx') && mainContainer.scrollTop > 200) {
              $this.KsBtnIsfixed = true
            }
          }
        }
      }
      //给页面绑定滑轮滚动事件
      if (document.addEventListener) { //firefox
        document.addEventListener('DOMMouseScroll', scrollFunc, false);
      }
      //滚动滑轮触发scrollFunc方法 //ie 谷歌
      window.onmousewheel = document.onmousewheel = scrollFunc;

      mainContainer.onscroll = function() {
        // 考试页面的右侧的指示
        if (($this.$route.path == '/Kaoshi' || $this.$route.path == '/Ckjx') && mainContainer.scrollTop <= 200) {
          $this.KsBtnIsfixed = false
        }
        // 考试页面的右侧的指示
        if (($this.$route.path == '/Kaoshi' || $this.$route.path == '/Ckjx') && mainContainer.scrollTop > 200) {
          $this.KsBtnIsfixed = true
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
  }

  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  .mainContainer {}

  #kefu {
    position: fixed;
    right: 10px;
    height: 100px;
    width: 60px;
    background-color: rgba(255, 255, 255, 0.5);
    top: 50vh;
    cursor: pointer;
  }

  .xdHeader {
    height: 114px;
    width: 100%;
    background: url(../assets/images/home_top_bg.png);
    position: relative;
  }

  #globalheader {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 99;
  }
  .bigRouterFooter {
    height: 349px;
    background-color: #fff;
    text-align: left;
    font-size: 14px;
  }

  .footer-big-tit {
    padding-top: 78px;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 600;
    text-align: left;
    color: #333333;
  }

  .footer-big-div {
    margin-top: 30px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    line-height: 14px;
  }

  .allright-fixed {
    position: fixed;
    right: 25px;
    width: 68px;
    height: 352px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    top: calc(50vh - 131px);
    z-index: 99999;
    text-align: center;
  }

  .right-fixed {
    width: 68px;
    height: 328px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
  }

  .right-fixed .flex1 {
    flex: 1;
    width: 52px;
    margin: 0 auto;
    border-bottom: 1px dashed #D0D0D0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #333;
    cursor: pointer;
    position: relative;
  }

  .right-fixed .flex1:last-child {
    border-bottom: none;
  }

  .right-fixed .flex1 .showNot {
    position: absolute;
    top: -50%;
    right: 70px;
    padding: 20px;
    background-color: #fff;
    display: none;
    transition: all 0.3s linear;
  }

  .kfdhtit {
    height: 25px;
    opacity: 1;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    line-height: 25px;
    letter-spacing: 1px;
  }

  .showNot::after {
    position: absolute;
    content: "\E791";
    top: 50%;
    right: -12px;
    font-family: element-icons !important;
    color: #fff;
    font-size: 20px;
    margin-top: -10px;
  }

  .right-fixed .flex1:hover .showNot {
    display: block;
  }

  .toBack {
    width: 68px;
    height: 75px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.04);
    margin-top: 20px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue